import React from "react";
import { Skeleton, SkeletonVariant } from "../Skeleton";
import { AnalysisItem } from "../AnalysisItem";
import { List } from "../List";
import { InfoLabel } from "../InfoLabel";
import css from "./NextMoveAnalysis.module.scss";

export interface NextMoveAnalysisProps {
  isLoading: boolean;
  items: string[];
}

const NextMoveAnalysis: React.FC<NextMoveAnalysisProps> = ({ isLoading, items }) => {
  const attrs = {
    analysisItem: {
      isLoading,
    },
    container: {
      className: css.container,
    },
    skeleton: {
      rows: 2,
      variant: SkeletonVariant.List,
    },
    list: {
      items,
    },
    infoLabel: {
      text: "No Suggestions at the moment",
      tooltip: "TODO",
    },
  };

  if (isLoading) {
    return (
      <AnalysisItem {...attrs.analysisItem}>
        <div {...attrs.container}>
          <Skeleton {...attrs.skeleton} />
          <Skeleton {...attrs.skeleton} />
          <Skeleton {...attrs.skeleton} />
          <Skeleton {...attrs.skeleton} />
        </div>
      </AnalysisItem>
    );
  }

  if (!items.length) {
    return (
      <AnalysisItem {...attrs.analysisItem}>
        <div {...attrs.container}>
          <InfoLabel {...attrs.infoLabel} />
        </div>
      </AnalysisItem>
    );
  }

  return (
    <AnalysisItem {...attrs.analysisItem}>
      <div {...attrs.container}>
        <List {...attrs.list} />
      </div>
    </AnalysisItem>
  );
};

export default NextMoveAnalysis;
